import React from "react";
import { Button, Tooltip } from "antd";
import { EyeTwoTone } from '@ant-design/icons';

const ViewButton = props => {
  return (
    <Tooltip 
      title={ props.btnTitle ? props.btnTitle : 'Ver' } 
      placement="left">
      <Button 
        shape="circle" 
        size="small" 
        //type={ props.btnType ? props.btnType : 'primary' } 
        icon={ props.icon ? props.icon : <EyeTwoTone twoToneColor="#f15e21" /> }
        onClick={ props.onClick }
      />
    </Tooltip>
  );
}

export default ViewButton;